export const getAttributeShortId = (longId: string, baseProductId: number) => {
  const parts = longId.split(`_${baseProductId}_`);
  const attributeIdWithoutSuffix = parts[0];
  return attributeIdWithoutSuffix;
};
